import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#fff"
        fillOpacity="0.9"
        d="M9 18V9h1.5v9H9zM13.5 9v9H15V9h-1.5z"
      ></path>
      <path
        fill="#fff"
        fillOpacity="0.9"
        d="M15.75 4.5H21V6h-1.5v15a1.5 1.5 0 01-1.5 1.5H6A1.5 1.5 0 014.5 21V6H3V4.5h5.25V2.7a1.2 1.2 0 011.2-1.2h5.1a1.2 1.2 0 011.2 1.2v1.8zm-6 0h4.5V3h-4.5v1.5zM6 6v15h12V6H6z"
      ></path>
    </svg>
  );
}

export default Icon;
